export function useIsInternal() {
  const session = useUserSession()
  return computed(() => isInternalEmail(session.user.value?.email))
}
